import { useMemo } from "react";

import type { ActivationAlertsContractNewsTopic } from "@similarweb/pro-api-client";

import { useApiQuery } from "app/modules/api-client";

import { useCommonAlertsQueryParams } from "../../../useCommonAlertsQueryParams";

export const useTopicCounts = () => {
    const params = useCommonAlertsQueryParams();

    const { data, isLoading } = useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsNewsDetail",
            options: {
                // Subscribe to cached data from useNewsAlerts without triggering a separate fetch
                enabled: false,
            },
        },
        params,
    );

    const topicCounts = useMemo(() => {
        if (!data) {
            return undefined;
        }

        return data.reduce<Partial<Record<ActivationAlertsContractNewsTopic, number>>>((counts, item) => {
            counts[item.topic] = (counts[item.topic] ?? 0) + 1;
            return counts;
        }, {});
    }, [data]);

    return { isLoading, topicCounts };
};
